import React from 'react';
import Text from '~/components/Text';

const Title = ({ title }: { title: string }) => {
  return <Text className="font-medium mt-8 mb-4 text-base">{title}</Text>;
};

export default Title;
